//@flow

import * as request from '../utils/request';
import * as urls from '../urls';
import {UNLIMITED_PAGE_SIZE} from '../utils/constants';

export const requestTeams = (args: any) =>
  request.get(urls.TEAMS_API_URL, {page_size: UNLIMITED_PAGE_SIZE, ...args});
